import postAPI from './postAPI.js'

export default async function getTenantTaskInstance(taskInstanceId) {
    const data = await postAPI('taskinstances/get', { id: taskInstanceId });
    return data;
}
